import React, { useState, useEffect, useRef } from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSpring, animated } from 'react-spring';
import logo from '../images/logo.png';

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const agenciesAndServices = [
    {
      name: "Travel",
      to: "/travel",
      keywords: ["dv lottery", "passport", "flight", "visa"]
    },
    {
      name: "Security",
      to: "/security",
      keywords: ["guard", "cctv", "surveillance"]
    },
    {
      name: "Cleaning",
      to: "/cleaning",
      keywords: ["maid", "deep cleaning", "home cleaning"]
    },
    {
      name: "Real Estate & Management",
      to: "/realestate",
      keywords: ["apartment", "house", "property", "rent"]
    },

    {
      name: "Construction",
      to: "/construction",
      keywords: ["building", "contractor", "architecture"]
    }
  ];
  
  const searchRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setShowSearch(false);
    }
  };
  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);

  
  


  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openSection, setOpenSection] = useState(null);
  const sidebarRef = useRef(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const handleNavClick = () => {
    setSidebarOpen(false);
    setOpenSection(null);
  };
  useEffect(() => {
    if (searchQuery.trim() === '') return;
  
    // TODO: Replace with your own logic (e.g., filter, fetch, navigate)
    console.log('Live search for:', searchQuery);
  
    // Example: Navigate to a search page
    // navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
  }, [searchQuery]);
  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
        setOpenSection(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setSidebarOpen(false);
        setOpenSection(null);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Springs
  const agenciesSpring = useSpring({
    to: { maxHeight: openSection === 'agencies' ? '500px' : '0px', opacity: openSection === 'agencies' ? 1 : 0 },
    from: { maxHeight: '0px', opacity: 0 },
    config: { duration: 400 },
  });

  const aboutSpring = useSpring({
    to: { maxHeight: openSection === 'about' ? '300px' : '0px', opacity: openSection === 'about' ? 1 : 0 },
    from: { maxHeight: '0px', opacity: 0 },
    config: { duration: 400 },
  });

  const loginSpring = useSpring({
    to: { maxHeight: openSection === 'login' ? '300px' : '0px', opacity: openSection === 'login' ? 1 : 0 },
    from: { maxHeight: '0px', opacity: 0 },
    config: { duration: 400 },
  });

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="logo-wrapper">
            <a href="/">
              <img src={logo} alt="logo" className="logo" />
            </a>
          </div>

          <div className="search-wrapper" ref={searchRef}>
  <FontAwesomeIcon
    icon={faSearch}
    className="search-icon"
    onClick={() => setShowSearch((prev) => !prev)}
  />

  {showSearch && (
    <div className="search-bar">
      <input
        type="text"
        placeholder="Search agencies or services..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        autoFocus
      />
    </div>
  )}

  {showSearch && searchQuery && (
    <div className="search-results">
{(() => {
  const filteredResults = agenciesAndServices.filter((item) => {
    const query = searchQuery.toLowerCase();
    return (
      item.name.toLowerCase().includes(query) ||
      item.keywords?.some(keyword => keyword.toLowerCase().includes(query))
    );
  });

  if (filteredResults.length === 0) {
    return <div className="search-result-item">No results found.</div>;
  }

  return filteredResults.map((match, idx) => (
    <Link
      to={match.to}
      key={idx}
      className="search-result-item"
      onClick={() => setShowSearch(false)}
    >
      {match.name}
    </Link>
  ));
})()}

    </div>
  )}
</div>






          <nav className="desktop-nav">
            <ul className="desktop-nav-list">
              <li>
                <Link to="/" className="desktop-nav-link" onClick={handleNavClick}>HOME</Link>
              </li>
              <li className="desktop-nav-item">
                <Link to="#" className="desktop-nav-link">AGENCIES</Link>
                <ul className="desktop-dropdown">
                  <li><a href="/travel" className="desktop-dropdown-link">Travel Agency</a></li>
                  <li><a href="/security" className="desktop-dropdown-link">Security Agency</a></li>
                  <li><a href="/cleaning" className="desktop-dropdown-link">Cleaning Agency</a></li>
                  <li><a href="/realestate" className="desktop-dropdown-link">Real Estate Agency</a></li>
                  <li><a href="/construction" className="desktop-dropdown-link">Construction Agency</a></li>
                </ul>
              </li>
              <li className="desktop-nav-item">
                <Link to="#" className="desktop-nav-link">ABOUT</Link>
                <ul className="desktop-dropdown">
                  <li><a href="/aboutus" className="desktop-dropdown-link">About VOETA</a></li>
                  <li><a href="/privacy" className="desktop-dropdown-link">Privacy Policy</a></li>
                  <li><a href="/terms" className="desktop-dropdown-link">Terms of Use</a></li>
                  <li><a href="/jobs" className="desktop-dropdown-link">Jobs</a></li>
                </ul>
              </li>
              <li className="desktop-nav-item">
                <Link to="#" className="desktop-nav-link">LOG IN</Link>
                <ul className="desktop-dropdown">
                  <li><a href="/clientportal" className="desktop-dropdown-link">Client Portal</a></li>
                  <li><a href="/employeeportal" className="desktop-dropdown-link">Employee Portal</a></li>
                </ul>
              </li>
            </ul>
          </nav>

          <button
            className={`menu-toggle ${sidebarOpen ? 'open' : ''}`}
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle menu"
            aria-expanded={sidebarOpen}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>
     

      {/* Sidebar Navigation (Mobile) */}
      <aside ref={sidebarRef} className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <ul className="sidebar-list">
          <li>
            <Link to="/" className="sidebar-link" onClick={handleNavClick}>HOME</Link>
          </li>

          {[
            {
              id: 'agencies',
              label: 'AGENCIES',
              spring: agenciesSpring,
              links: [
                { to: '/travel', text: 'Travel Agency' },
                { to: '/security', text: 'Security Agency' },
                { to: '/cleaning', text: 'Cleaning Agency' },
                { to: '/realestate', text: 'Real Estate Agency' },
                { to: '/construction', text: 'Construction Agency' },
              ],
            },
            {
              id: 'about',
              label: 'ABOUT',
              spring: aboutSpring,
              links: [
                { to: '/aboutus', text: 'About VOETA' },
                { to: '/privacy', text: 'Privacy Policy' },
                { to: '/terms', text: 'Terms of Use' },
                { to: '/jobs', text: 'Jobs' },
              ],
            },
            {
              id: 'login',
              label: 'LOG IN',
              spring: loginSpring,
              links: [
                { to: '/clientportal', text: 'Client Portal' },
                { to: '/employeeportal', text: 'Employee Portal' },
              ],
            },
          ].map(({ id, label, spring, links }) => (
            <li className="accordion-item" key={id}>
                  {/* Divider  accordion label */}
              <hr className="label-divider" />
              <button
                className="accordion-toggle"
                onClick={() => toggleSection(id)}
                aria-expanded={openSection === id}
                aria-controls={`${id}-accordion`}
              >
                {label}
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`chevron-icon ${openSection === id ? 'rotate' : ''}`}
                />
              </button>

            

              <animated.div style={spring} className="accordion-content" id={`${id}-accordion`}>
                {links.map(({ to, text }) => (
                  <Link key={to} to={to} className="accordion-link" onClick={handleNavClick}>
                    {text}
                  </Link>
                ))}
              </animated.div>
              
            </li>
          ))}
        </ul>
      </aside>
      </header>

      {/* CSS Styles */}
      <style>{`
        /* Reset all text decorations and list styles */
header a,
header a:visited,
header a:hover,
header a:active,
header button,
aside a,
aside a:visited,
aside a:hover,
aside a:active,
aside button {
  text-decoration: none !important;
  list-style: none !important;
}

header ul,
header ol,
aside ul,
aside ol {
  list-style: none !important;
  padding-left: 0;
  margin: 0;
}


        .header {
          position: sticky; /* instead of fixed */
          top: 0;
          background-color: rgb(0, 0, 77);
          padding: 10px 20px;
          color: white;
          width: 100%;
          z-index: 1000;
          box-sizing: border-box;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

        .header .container {
          max-width: 1500px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .header .logo-wrapper {
          display: flex;
          align-items: center;
          user-select: none;
        }

        .header .logo {
          max-height: 40px;
          width: auto;
          margin-right: 10px;
        }

        .header .desktop-nav {
          display: flex;
          align-items: center;
          background-color: transparent;
          padding: 0;
          height: auto;
        }

       .header .desktop-nav-list {
          list-style: none;
          padding-left: 0;
          margin: 0;
          display: flex;
          gap: 10px;
        }
          

        .header .desktop-nav-link,
        .desktop-dropdown-link {
          color: white; font-weight: 500; padding: 10px 20px; text-decoration: none !important; display: block;
        }

        .header .desktop-nav-item {
          position: relative;
          text-decoration: none;
        }

        .header .desktop-dropdown {
          display: none;
          background-color: rgb(0, 0, 77);
          position: absolute;
          top: 100%;
          min-width: 250px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          text-decoration: none;
        }

        .header .desktop-nav-item:hover .desktop-dropdown {
          display: block;
        }

        .header .desktop-dropdown-link:hover {
          background-color: red;
        }

        .header .menu-toggle {
          display: none;
          flex-direction: column;
          cursor: pointer;
          background: none;
          border: none;
        }

        .header .bar {
          width: 25px;
          height: 3px;
          background-color: white;
          margin: 4px 0;
        }
      
        .header .sidebar-link,
        .accordion-link {
          color: white;
          font-weight: 500;
          font-size: 15px;
          padding-top: 10px;
          padding-left: 10px;
          padding-right: 10px;
          text-decoration: none !important;
          display: block;
        }  

        .header .sidebar {
          display: none;
          position: fixed;
          top: 0;
          left: -300px;
          width: 300px;
          height: 100%;
          background-color: red;
          transition: left 0.3s ease;
          z-index: 1500;
          overflow-y: auto;
    
        }

        .header .sidebar.open {
          left: 0;
        }

        .header .sidebar-list {
          list-style: none;
          padding-left: 0;
          margin: 0;
        }

        .header .accordion-item {
          margin: 0;
        }

        .header .accordion-toggle {
          background: none;
          border: none;
          color: white;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding-left: 10px;
          padding-right: 10px;
          font-size: 15px;
          text-decoration: none !important;
        }

        .header .chevron-icon {
          transition: transform 0.3s ease;
        }

        .header .rotate {
          transform: rotate(180deg);
        }

        .header .accordion-content {
          overflow: auto;
          display: flex;
          flex-direction: column;
        }

        .header .accordion-link {
          color: white;
          font-weight: 400;
          padding: 8px 20px;
          text-decoration: none !important;
        }

        .header .accordion-link:hover {
          background-color: rgb(0, 0, 77);
        }

        .header .label-divider {
          border: none;
          border-top: 1px solid rgba(255, 255, 255, 0.3);
    
          width: 100%;
        }
.header .search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  width: 250px; /* make consistent width */
}


.header .search-bar {
  transition: width 0.3s ease;
  background-color: white;
  border-radius: 20px;
  overflow: hidden;
  height: 36px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header .search-bar input {
  border: none;
  outline: none;
  font-size: 14px;
  background-color: transparent;
  color: black;
  width: 100%;
  height: 100%;
}

.header .search-icon {
  color: white;
  cursor: pointer;
  font-size: 18px;
  margin-left: 1rem;
}

.header .search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 5px;
  background: white;
  color: black;
  width: 100%;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  max-height: 300px;
  overflow-y: auto;
  z-index: 2001;
  display: flex;
  flex-direction: column;
}

.header .search-result-item {
  padding: 10px;
  cursor: pointer;
}

.header .search-result-item:hover {
  background: #f0f0f0;
}

@media (max-width: 1268px) {
          .header .desktop-nav { display: none; }
          .header .menu-toggle { display: flex; }
          .header .sidebar { display: block; }

            .header .search-results {
    width: 100%;
    left: 5px;
    right: 5px;
  }
        }

@media (max-width: 768px) {


  .header .search-wrapper {
    width: 100%;
    justify-content: space-between;
  }

  .header .search-bar {
    width: 100%;
  }

  .header .search-results {
    left: 5px;
    right: 5px;
    width: 100%;
  }

  .header .sidebar-link,
  .header .accordion-link {
    font-size: 18px;
  }

  .header .accordion-toggle {
    font-size: 16px;
  }
}


      `}</style>
    </>
  );
};

export default Header;
